import { flexRender } from '@tanstack/react-table';
import cx from 'clsx';
import type React from 'react';

type TableHeaderProps = {
  table: any;
  wrapHeaders: boolean;
  onReorder?: ((newOrder: any[]) => void) | undefined;
};

export const TableHeader: React.FC<TableHeaderProps> = ({ table, wrapHeaders, onReorder }) => (
  <thead data-role="thead" className="sticky top-0 z-20 m-0 bg-white shadow-[inset_0_-1px_0] shadow-slate-300">
    {table.getHeaderGroups().map((headerGroup) => (
      <tr data-role="tr" key={headerGroup.id} className="flex w-full place-content-between">
        {!!onReorder && <th className="w-5 p-0" />}
        {headerGroup.headers.map((header) => (
          <th
            data-role="th"
            key={header.id}
            colSpan={header.colSpan}
            className={cx('flex border-grey-border p-3 text-left align-top', !wrapHeaders && 'truncate', header.column.columnDef.meta?.className)}
            style={{ width: header.getSize() }}
          >
            {header.isPlaceholder ? null : (
              <div className={cx('font-normal text-gray-500', header.column.getCanSort() && 'cursor-pointer select-none')} onClick={header.column.getToggleSortingHandler()}>
                {flexRender(header.column.columnDef.header, header.getContext())}
                {{
                  asc: ' ↑',
                  desc: ' ↓',
                }[header.column.getIsSorted() as string] ?? null}
              </div>
            )}
          </th>
        ))}
      </tr>
    ))}
  </thead>
);
